import RenderMessage from '../../../garvan-react/Components/ModalFeedback/RenderMessage'
import React from 'react'

export const invalid_access =
  'This page can only be accessed from a Sample Run (contextual information required).'
function InvalidAccessAlert() {
  return (
    <RenderMessage
      message={{
        message: invalid_access,
        subject: 'Unable to proceed',
        severity: 'warning',
        loading: false,
      }}
    />
  )
}

export default InvalidAccessAlert
